// Animer l'affichage des profils
function animateProfiles() {
  // Cacher la photo de l'étape 1
  $('.js-picture, .profiles').toggleClass('hidden');

  // Afficher les photos de profil
  $('.js-profiles-picture').each(function (i) {
    $(this)
      .css('animation-delay', ++i * 250 + 'ms')
      .addClass('animated flipInY');
  });
}

// Animer le compteur de profils
function animateCounter(counter) {
  var i = 0;
  var delay = 200;
  /* Total aléatoire entre 20 et 25 */
  var random = Math.floor(Math.random() * 5 + 20);
  var incrementCounter = function () {
    window.clearInterval(interval);

    counter.text(i);

    i++;

    if (i !== random) {
      /* Interval aléatoire entre 100 et 400, par pallier de 100 */
      delay = 100 + 100 * Math.floor(Math.random() * 3);
      interval = window.setInterval(incrementCounter, delay);
    } else {
      $('.js-step[data-step="2"] .js-form-poll').submit();
    }
  };
  var interval = window.setInterval(incrementCounter, delay);
}

(function ($) {
  $('.js-form-poll').on('submit', function (e) {
    e.preventDefault();

    var step = +($(this).find('[name="step"]').val());
    var section = $(this).parents('.js-step');
    var nextSection = $('.js-step[data-step="' + (step + 1) + '"]');

    section.addClass('hidden');
    nextSection.removeClass('hidden');

    if (step == 1) {
      animateProfiles();
      animateCounter($('.js-total-profiles'));
    } else if (step == 8) {
      $('.js-redirect-link').attr('href', $(this).find('[name="category"]:checked').val());
    }
  });
})(jQuery);
